import { render, staticRenderFns } from "./DefaultPageMenu.vue?vue&type=template&id=16e35c44&scoped=true&"
import script from "./DefaultPageMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultPageMenu.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageMenu.vue?vue&type=style&index=0&id=16e35c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e35c44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
